import React, { useMemo, useState } from 'react'

import { HEX_CODES, DEAL_STAGE_CATEGORIES, DEAL_LABELS } from '../../constants/Map'; // Adjust import path as needed
import  mappointer  from "../../assets/map-icon.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap, faLocationDot } from '@fortawesome/free-solid-svg-icons'

import { latlonDataWithColors } from "../../services/Map";

import {
  AdvancedMarker,
  Pin,

} from "@vis.gl/react-google-maps";

function Cardmap({ latlonData, selectedDimension }) {

  

  const latlonStageCategory = latlonData.map((data) => (data.data.stage_category));
  const latlonDealLabel = latlonData.map((data) => (data.data.stagelabel));
  const findUniqueData = (array) => {
    const countOccurrences = array.reduce((acc, item) => {
      if (item !== null  && item !== 'Demo Scheduled' && item !== 'Demo Scheduled' && item !== "Appointment Set"  ) {
        acc[item] = (acc[item] || 0) + 1;
      }
      return acc;
    }, {});
  

    return array.filter(item => countOccurrences[item] >= 1 && item !== "Appointment Set"  );
  };
  const latlonUniqueData = [...new Set(findUniqueData(latlonStageCategory))];
  const latlonUniqueDealLabel = [...new Set(findUniqueData(latlonDealLabel))];



  

 


  return (
    <div>


      {(selectedDimension === 'Deal Stage Category' || selectedDimension === 'Deal Label' || selectedDimension !== '' ) &&  (latlonUniqueData.length > 0 || latlonUniqueDealLabel.length > 0)  && (
        <div className="card-map">
          
          
          {(selectedDimension === 'Deal Stage Category' && latlonUniqueData.length > 0  ) && (
          <>
            <h5 className="card-title1">Deal Stage Category</h5> 
            {latlonUniqueData.map((item, ind) => (
              <div key={ind} className="card-body-container">
                {console.log("latlonDataWithColors", latlonDataWithColors(selectedDimension, item))}
                <FontAwesomeIcon   className='map-pointer fa-border' icon={faLocationDot} style={{ color: latlonDataWithColors(selectedDimension, item), border: '#000', borderRadius: '50%' } } />
                <span className="card-point1">{item}</span>
              </div>
            ))}
          </>
        )}

{(selectedDimension === 'Deal Label' && latlonUniqueDealLabel.length > 0 ) && (
          <>
            <h5 className="card-title2">Deal Label</h5> 
            {latlonUniqueDealLabel.map((item, ind) => (
              <div key={ind} className="card-body-container">
                {console.log("latlonDataWithColors", latlonDataWithColors(selectedDimension, item))}
                <FontAwesomeIcon className='map-pointer' icon={faLocationDot} style={{ color: latlonDataWithColors(selectedDimension, item)
   }} />
                <span className="card-point2">{item}</span> 
              </div>
            ))}
          </>
        )}
        
      </div>
    )}

        </div>
      )}





    






export default Cardmap